import { instance } from "libs/api";

import { ApiRoutesMarketing } from "../../constants";
import { CampaignEstimate, CampaignEstimateParams } from "../../marketing.types";

export const requestGetCampaignEstimate = async (
  params: CampaignEstimateParams
): Promise<CampaignEstimate> => {
  return await instance.post(ApiRoutesMarketing.CampaignsEstimate, params);
};
